import React, { useRef, useEffect, useContext, useState, useMemo, useCallback } from 'react'
import { base64ToUint8Array } from '@/utils'
import { FilterContext } from '@/App'
import { Talk } from '@/packages/sdk/talk'
import { Socket } from '@/packages/sdk/socket'
import { RENDER_SDK, RESOURCE_MANAGER, SOCKET_INS } from '@/config'
import { Avatar, Button, CapsuleTabs, Mask, Popup, SpinLoading } from 'antd-mobile'
import './index.scss'

import MessageComp from './components/MessageComp'
import VoiceTypeTabContent from './components/VoiceTypeTabContent'
import { AvatarContext } from '@/components/RenderComp/Avatar'
import FUIcon from '@/components/Common/FUIcon'
import { RendererContext } from '@/components/FURenderkit'
export enum TaskState {
    TASK_IDLE,
    TASK_STARTING,
    TASK_RUNNING,
    TASK_CANCELLING,
}
export const TALK_INS = new Talk({
    PCMConfig: {
        encoding: "16bitInt", // PCM 格式
        channels: 1, // 声道数
        sampleRate: 16000, // 采样率
    },
    locateFile: (path) => `/${path}`,
    manul: false, // 是否手动控制播放启动
})

interface IMessage {
    id
    target
    msg
}

const TalkSkill = React.forwardRef((props: any, ref) => {
    const { style } = props
    const { loading, setLoading } = useContext(RendererContext)
    const { avatarConfig, inTalkSessionRef, avatar } = useContext(AvatarContext) as FilterContext<typeof AvatarContext>
    const [voiceType, setVoiceType] = useState('Kenny')
    const [currentDemoId, setCurrentDemoId] = useState('')
    const talkStateRef = useRef<any>()
    const uuidRef = useRef('')
    useEffect(() => {
        (async () => {
            if (!avatarConfig) return
            RESOURCE_MANAGER.getTalkSkills()
            RESOURCE_MANAGER.getVoiceList()
            // RESOURCE_MANAGER.getAnimationList()

            // 初始化 talk实例
            await TALK_INS.initialize()
            TALK_INS.registerOnEnd(() => {
                setCurrentDemoId('')
                changeState(TaskState.TASK_IDLE)
            })

            // 初始化socket并连接
            SOCKET_INS.initialize(
                RESOURCE_MANAGER.token,
                () => {
                    changeState(TaskState.TASK_IDLE)
                    setLoading(false)
                }
            )
            // 订阅socket tts事务
            if (avatarConfig.data.gender === "male") {
                setVoiceType("Kenny")
            } else {
                setVoiceType("Aiqi")
            }
            SOCKET_INS.on("tts", subscribe)
            handleTalkInited()
        })()
        return () => {
            SOCKET_INS.off("tts", subscribe)
            handleTalkShutdown()
        }
    }, [avatarConfig])

    const subscribe = (res) => {
        if (talkStateRef.current === TaskState.TASK_CANCELLING) {
            return
        }
        let { audio, end, timestamp, uuid, timestampFormat } = res.data
        if (uuid === uuidRef.current) {
            const int16Arr = new Int16Array(
                base64ToUint8Array(audio)
            )
            if (end === true) {
                TALK_INS.setRequestStop()
                if (timestampFormat !== 'text') {
                    // 音素类型的tts需要判断最后一条timestamp是否是silence，silence会有动画时间差
                    const strArr = timestamp.split(/[(\r\n)\r\n]+/)
                    let endSign = 'sil'
                    let lastStr
                    while (endSign === 'sil') {
                        lastStr = strArr.pop()
                        endSign = lastStr.split(' ').pop()
                    }
                    strArr.push(lastStr)
                    timestamp = strArr.join('\n')
                }
            }
            TALK_INS.feedPhenome(timestamp + '\n', timestampFormat === 'text')
            TALK_INS.feedPCM(int16Arr)
        }
    }

    function handleTalkInited() {
        avatar.setAnimationGraphParamBool("MaskActive", 1);
    }

    function handleTalkShutdown() {
        if (avatar) {
            interrupt()
            SOCKET_INS.close()
            avatar.setAnimationGraphParamBool("MaskActive", 2);
        }
    }
    function handleTalkSessionBegin() {
        inTalkSessionRef.current = true
    }
    function handleTalkSessionEnd() {
        const exp = TALK_INS.getCurrentExpression(-1);
        inTalkSessionRef.current = false
        avatar.setAvatarMouthBlendShape(exp);
    }

    function changeState(state) {
        if (talkStateRef.current !== state) {
            if (
                talkStateRef.current === TaskState.TASK_RUNNING
            ) {
                // 从对话中切走, 重置表情
                handleTalkSessionEnd()
            }
            talkStateRef.current = state
        }
    }

    const isWatingTts = useRef(false)
    async function emitByText(content, isRecord = true, demoVoice?) {
        if (isWatingTts.current) {
            return
        }
        isWatingTts.current = true
        if (talkStateRef.current === TaskState.TASK_RUNNING) {
            await interrupt()
        }
        changeState(TaskState.TASK_STARTING)
        if (isRecord) {
            messagecompRef.current.recordLog(1, content)
        }
        SOCKET_INS.emit(
            "message",
            {
                nlp: {
                    question: content,
                },
                tts: {
                    ratioVolume: 1,
                    ratioSpeed: 1,
                    format: "pcm",
                    voice: demoVoice || voiceType,
                    sampleRate: 16000,
                }
            },
            (response) => {
                isWatingTts.current = false
                if (response.code === 0) {
                    uuidRef.current = response.data.tts.uuid
                    if (isRecord) {
                        messagecompRef.current?.recordLog(
                            0,
                            response.data.nlp.originText
                        )
                    }
                    changeState(TaskState.TASK_RUNNING)
                    handleTalkSessionBegin()
                } else {
                    // 服务端处理失败，回到初始状态
                    changeState(TaskState.TASK_IDLE)
                }
            }
        )
    }
    async function emitByAudio(base64data) {
        if (talkStateRef.current === TaskState.TASK_RUNNING) {
            await interrupt()
        }
        changeState(TaskState.TASK_STARTING)
        SOCKET_INS.emit(
            "message",
            {
                asr: {
                    audio: base64data.replace("data:audio/pcm;base64,", ""),
                    format: 'pcm',
                },
                nlp: {
                    robotId: "chatbot-cn-3z7IBIBeEf",
                },
                tts: {
                    voice: voiceType,
                },
            },
            (response) => {
                if (response.code === 0) {
                    uuidRef.current = response.data.tts.uuid
                    messagecompRef.current.recordLog(
                        1,
                        response.data.asr.text
                    )
                    messagecompRef.current.recordLog(
                        0,
                        response.data.nlp.originText
                    )
                    changeState(TaskState.TASK_RUNNING)
                    handleTalkSessionBegin()
                } else {
                    // 服务端处理失败，回到初始状态
                    changeState(TaskState.TASK_IDLE)
                }
            }
        )
    }

    function interrupt() {
        return new Promise((resolve) => {
            if (talkStateRef.current !== TaskState.TASK_RUNNING && talkStateRef.current !== TaskState.TASK_STARTING) {
                return resolve(true)
            }

            if (currentDemoId) {
                setCurrentDemoId('')
            }

            if (uuidRef.current) {
                changeState(TaskState.TASK_CANCELLING)
                SOCKET_INS.emit(
                    "message",
                    {
                        tts_cancel: {
                            uuid: uuidRef.current,
                        }
                    },
                    (res) => {
                        if (res.code === 0) {
                            uuidRef.current = ''
                            changeState(TaskState.TASK_IDLE)
                            resolve(true)
                        }
                    }
                )
            }

            TALK_INS.stop()
        })
    }

    const messagecompRef = useRef<any>(null)
    const [logs, setLogs] = useState<IMessage[]>([])
    const messageContainerRef = useRef<any>(null)
    const [showType, setShowType] = useState('')

    useEffect(() => {
        if (logs.length > 0) {
            messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
        }
    }, [logs, showType])

    return (
        <div style={style}>
            {
                loading
                    ? (
                        <Mask>
                            <SpinLoading color='primary' />
                        </Mask>
                    )
                    : (
                        <div className="skill-container">
                            <div className="tab-container">
                                <div
                                    className={'message-container better-scroll' + (showType === 'history' ? ' active' : '')}
                                    ref={messageContainerRef}
                                >
                                    {
                                        logs.length > 0 ? logs.map(log => (
                                            <p
                                                key={log.id}
                                                className={log.target === 0 ? 'receive' : 'send'}
                                            >
                                                {log.msg}
                                            </p>
                                        )) : (
                                            <p style={{ textAlign: 'center', margin: 'auto', fontSize: '16px' }}>
                                                暂无记录
                                            </p>
                                        )
                                    }
                                </div>
                                <MessageComp
                                    ref={messagecompRef}
                                    logs={logs}
                                    setLogs={setLogs}
                                    emitByText={emitByText}
                                    emitByAudio={emitByAudio}
                                    voiceType={voiceType}
                                    interrupt={interrupt}
                                />
                            </div>
                            <div
                                className="show-func-list-switch"
                            >
                                <FUIcon
                                    className="history-trigger"
                                    size="48px"
                                    name={showType === 'history' ? 'slices/icon_drawer_history_active.png' : 'slices/icon_drawer_history.png'}
                                    style={
                                        {
                                            cursor: 'pointer',
                                            borderRadius: '24px',
                                            backgroundColor: '#fff',
                                            top: showType ? '-205px' : '-120px'
                                        }
                                    }
                                    onClick={() => setShowType(showType === 'history' ? '' : 'history')}
                                />
                                <VoiceTypeTabContent
                                    voiceType={voiceType}
                                    setVoiceType={setVoiceType}
                                    currentDemoId={currentDemoId}
                                    setCurrentDemoId={setCurrentDemoId}
                                    interrupt={interrupt}
                                    emitByText={emitByText}
                                    showType={showType}
                                    setShowType={setShowType}
                                />
                                <div className="skill-list">
                                    {
                                        RESOURCE_MANAGER.talkSkills.map(({ name }) => {
                                            return (
                                                <Button
                                                    key={name}
                                                    className="skill"
                                                    fill="outline"
                                                    size="small"
                                                    onClick={() => emitByText(name)}
                                                >
                                                    {name}
                                                </Button>
                                            )
                                        })
                                    }
                                    <Button
                                        className="skill"
                                        fill="outline"
                                        size="small"
                                        onClick={() => handleTalkSessionEnd()}
                                    >
                                        停止
                                    </Button>
                                </div>
                            </div>
                        </div >
                    )
            }

        </div >
    )
})

export default TalkSkill
